import { Controller } from '@hotwired/stimulus';

const INVALID_CLASS = 'is-invalid';

export default class FormValidationController extends Controller {
  connect() {
    this.element.addEventListener('invalid', this.markInvalid, true);
    this.element.addEventListener('input', this.clearInvalid, true);
    this.element.addEventListener('change', this.clearInvalid, true);
  }

  disconnect() {
    this.element.removeEventListener('invalid', this.markInvalid, true);
    this.element.removeEventListener('input', this.clearInvalid, true);
    this.element.removeEventListener('change', this.clearInvalid, true);
  }

  markInvalid = (event) => {
    event.target.classList.add(INVALID_CLASS);
  };

  clearInvalid = (event) => {
    const field = event.target;
    if (field.classList.contains(INVALID_CLASS) && field.checkValidity()) {
      field.classList.remove(INVALID_CLASS);
    }
  };
}
